export default "__VITE_ASSET__BJ2Us1ju__"